import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { LOCAL_RESOURCES, PLATFORM_LANGUAGES } from '@thinknet-gmbh/platform-common';

import 'moment/locale/de';

export const availableLanguages = Object.keys(LOCAL_RESOURCES);

i18n.use(initReactI18next).init({
  resources: LOCAL_RESOURCES,
  defaultNS: 'common',
  fallbackLng: PLATFORM_LANGUAGES.en,
});
